export var CATEGORY_TYPE = {
  PILL: 'pills',
  SEARCH: 'search',
  AUTO_COMPLETE: 'autoComplete',
  MULTIPLE_SEARCH: 'multipleSearch'
};
export var OPTION_TYPE = {
  CUSTOM_DATE: 'CUSTOM_DATE',
  YESTERDAY: 'YESTERDAY',
  TODAY: 'TODAY',
  WEEK: 'WEEK',
  ONE_MONTH: 'ONE_MONTH',
  TWO_MONTH: 'TWO_MONTH',
  THREE_MONTH: 'THREE_MONTH',
  CUSTOM_NUMBER_RANGE: 'CUSTOM_NUMBER_RANGE',
  CUSTOM_NUMBER: 'CUSTOM_NUMBER'
};
//# sourceMappingURL=contants.js.map
